<template>
	<span class="productAttr">
				
				<div v-if="product.product_type == 2" class="productSize"  v-bind:class="{ showproductSize:mysizeactive==1}">
				  <b-row v-for="(item, index) in product.variation_attributes" :key="item">
					<b-col class="p-0">
					 <b-row class="m-0">
						<b-col class="p-0 product-attribute-title " cols="3">
						 Select {{item}}  
						</b-col>
						<b-col class="p-0 product-attribute-title " v-if="$root.addtocartAlert!=''">
						<b-alert show variant="warning" class="addtocartAlert">{{$root.addtocartAlert}}</b-alert>
				 
						</b-col>
					  </b-row> 
					  <b-row class="m-0 sizeRow">
						<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" class="px-1 p-1">
						  <div class="product-attribute" v-bind:class="{ active: selected_attributes[index] == variationitem.attributes[index].value }" v-on:click="onSelectAttribute(variationitem, index),mysizeactive=1">
						  {{variationitem.attributes[index].value}}
							<!--{{variationitem.attributes[index]}} 
							<b-img :src="variationitem.src"></b-img> -->
						  </div>
						</b-col>
						
					  </b-row>
					</b-col>
				  </b-row>
					 <!-- {{selected_attributes_id}}
					{{product.id}} 
					{{product.orgPId}} 
				 
				  <p>{{selected_attributes}}</p>  -->
				</div>
				<span>
				<b-link class="btn-solid btn2 mb-1" @click="$root.updateCart(product,1,selected_attributes,selected_attributes_id,$route.params.shareid),mysizeactive=1,inLodcard()">Buy Now</b-link> 
				</span>
				<!-- 
				@click="$root.updateCart(product, product_qty,selected_attributes,selected_attributes_id),initload()"
				-->
			<!-- {{inCartItem}} -->
	
	</span>
</template>
<script>
export default {
  name: 'ProductAttribute',
  props: {
    product: { type: Object },	
  },
  beforeMount(){
	 console.log('ddddd'+this.product.product_type);
	 if(this.product.product_type==2){
		/* if(this.product.orgPId!=''){
		this.product.id = this.product.orgPId;
		}*/
		//this.product.id.split('_');
		this.product.variation_attributes = this.product.variation_attributes.split("|");
		this.product.variations = JSON.parse(this.product.variations);
		this.selected_attributes = this.product.default_variation.split("|");
	 }
	 
	/* self.$root.cart.items.forEach((value, index) => {
		self.inCartItem.push(value.orgPId);
		console.log(value);
		console.log(index);
	});*/
	 
  },
  mounted(){
  this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
	  selected_attributes: [],
	  selected_attributes_id: '',
	  mysizeactive:0,
	  inCartItem:[],
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
		inLodcard(){
		 var self = this;
		 console.log('ddddd'+self.selected_attributes);
		/*if(self.product.product_type == 2){
				self.product.variation_attributes = self.product.variation_attributes.split("|");
				self.product.variations = JSON.parse(self.product.variations);
				self.selected_attributes = self.product.default_variation.split("|");
			}*/
		},
		 onSelectAttribute(variation, index){
                var t = this.selected_attributes.slice();
                t[index] = variation.attributes[index].value;
                this.selected_attributes = t;
                this.selected_attributes_id = variation.attributes[index].id;
				this.$root.addtocartAlert ='';
        },
		filterAttribute(variations, index){
			var self = this;
			var filterarr = [];
			if(index == 0){
					return variations.filter(function (variation) {
							if(filterarr.indexOf(variation.attributes[index].value) == -1){
									filterarr.push(variation.attributes[index].value);
									return true;
							}
							return false;
					})
			}else{
					return variations.filter(function (variation) {
							console.log(self.selected_attributes[index-1]);
							if(variation.attributes[index-1].value == self.selected_attributes[index-1]){
									//filterarr.push(variation.attributes[index].value);
									return true;
							}
							return false;
					})
			}
		},

		
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
element.style {
}

.productAttr{
	text-align: center;
	&:hover{
		.productSize{
			position: relative;
			visibility: visible;
			background: #ffffff;
		}
	}
	.productSize{
		position: absolute;
		visibility: collapse;
		width:220px;
	}
	
	.product-attribute-title{
	font-size: 12px;
    margin-left: 8px;
	}
	.product-attribute {
		border: 2px solid #E7E7E7;
		width: 100%;
		text-align: center;
		border-radius: 50%;
		padding: 9px 0px;
		color: #000000;
		background-color: #ffffff;
		cursor: pointer;
		width: 35px;
		height: 35px;
		background: #bd5df912;
		/*font-size: 10px;*/
		font-size: 0.6vw;
		&:hover{
			background-color: #c85df7;
			color:#ffffff;
		}
		
	}
	.active {
		  border: 2px solid #8100d3;
		  color: #ffffff;
		  background-color: #8100d3;
			.productSize{
				position: relative;
				visibility: visible;
				background: #ffffff;
			}
		}
		
		.alert-warning {
			    color: #856404;
				background-color: #fff3cd;
				border-color: #ffeeba;
				font-size: 11px;
				padding: 0px;
				padding-left: 3px;
				margin: 0px;
		}
		
		.showproductSize{
			position: relative;
			visibility: visible;
			
		}
}
</style>
